import React, { useState } from 'react';
import { X, Eye, EyeOff } from 'lucide-react';
interface PasswordChangeModalProps {
  onClose: () => void;
  onSuccess: () => void;
}
export function PasswordChangeModal({
  onClose,
  onSuccess
}: PasswordChangeModalProps) {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    // Validate password
    if (newPassword.length < 8) {
      setError('Şifre en az 8 karakter uzunluğunda olmalıdır.');
      return;
    }
    if (!/[A-Z]/.test(newPassword)) {
      setError('Şifre en az bir büyük harf içermelidir.');
      return;
    }
    if (!/\d/.test(newPassword)) {
      setError('Şifre en az bir rakam içermelidir.');
      return;
    }
    // Check if passwords match
    if (newPassword !== confirmPassword) {
      setError('Girdiğiniz yeni şifreler eşleşmiyor.');
      return;
    }
    // In a real app, we would call an API to change the password
    // For now, we'll simulate a successful password change
    setTimeout(() => {
      onSuccess();
      onClose();
    }, 1000);
  };
  return <div className="fixed inset-0 bg-black/75 flex items-center justify-center p-4 z-50" data-id="element-570">
      <div className="relative p-[1px] rounded-xl overflow-hidden bg-gradient-to-r from-purple-600 to-indigo-600 w-full max-w-md" data-id="element-571">
        <div className="relative bg-black/90 rounded-xl p-6" data-id="element-572">
          <div className="flex justify-between items-center mb-6" data-id="element-573">
            <h2 className="text-xl font-bold" data-id="element-574">Şifre Değiştir</h2>
            <button onClick={onClose} className="text-gray-400 hover:text-white" data-id="element-575">
              <X className="w-6 h-6" data-id="element-576" />
            </button>
          </div>
          <form onSubmit={handleSubmit} className="space-y-4" data-id="element-577">
            <div className="space-y-2" data-id="element-578">
              <label className="block text-sm font-medium" data-id="element-579">Mevcut Şifre</label>
              <div className="relative" data-id="element-580">
                <input type={showCurrentPassword ? 'text' : 'password'} value={currentPassword} onChange={e => setCurrentPassword(e.target.value)} className="w-full bg-white/5 text-white rounded-lg px-4 py-2.5 pr-10 focus:ring-2 ring-purple-500/20" required data-id="element-581" />
                <button type="button" className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-white" onClick={() => setShowCurrentPassword(!showCurrentPassword)} data-id="element-582">
                  {showCurrentPassword ? <EyeOff className="w-5 h-5" data-id="element-583" /> : <Eye className="w-5 h-5" data-id="element-584" />}
                </button>
              </div>
            </div>
            <div className="space-y-2" data-id="element-585">
              <label className="block text-sm font-medium" data-id="element-586">Yeni Şifre</label>
              <div className="relative" data-id="element-587">
                <input type={showNewPassword ? 'text' : 'password'} value={newPassword} onChange={e => setNewPassword(e.target.value)} className="w-full bg-white/5 text-white rounded-lg px-4 py-2.5 pr-10 focus:ring-2 ring-purple-500/20" required data-id="element-588" />
                <button type="button" className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-white" onClick={() => setShowNewPassword(!showNewPassword)} data-id="element-589">
                  {showNewPassword ? <EyeOff className="w-5 h-5" data-id="element-590" /> : <Eye className="w-5 h-5" data-id="element-591" />}
                </button>
              </div>
              <p className="text-xs text-gray-400" data-id="element-592">
                En az 8 karakter, bir büyük harf ve bir rakam içermelidir
              </p>
            </div>
            <div className="space-y-2" data-id="element-593">
              <label className="block text-sm font-medium" data-id="element-594">
                Yeni Şifre (Tekrar)
              </label>
              <div className="relative" data-id="element-595">
                <input type={showConfirmPassword ? 'text' : 'password'} value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} className="w-full bg-white/5 text-white rounded-lg px-4 py-2.5 pr-10 focus:ring-2 ring-purple-500/20" required data-id="element-596" />
                <button type="button" className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-white" onClick={() => setShowConfirmPassword(!showConfirmPassword)} data-id="element-597">
                  {showConfirmPassword ? <EyeOff className="w-5 h-5" data-id="element-598" /> : <Eye className="w-5 h-5" data-id="element-599" />}
                </button>
              </div>
            </div>
            {error && <p className="text-sm text-red-500" data-id="element-600">{error}</p>}
            <div className="pt-4 flex justify-end gap-3" data-id="element-601">
              <button type="button" onClick={onClose} className="px-4 py-2 bg-white/5 hover:bg-white/10 rounded-lg transition-colors" data-id="element-602">
                İptal
              </button>
              <button type="submit" className="px-4 py-2 bg-gradient-to-r from-purple-600 to-indigo-600 rounded-lg hover:opacity-90 transition-opacity" data-id="element-603">
                Kaydet
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>;
}